module.exports = __webpack_public_path__ + "static/media/network-rail-white-transparent.93d230f3.png";